module.exports = __webpack_public_path__ + "static/media/template2NonOneOnOne.0db788f4.png";